import React, { Fragment } from 'react';

import { PageTitle } from '../../../layout-components';
import MeetingPilot from '../../../flowtrace-components/MeetingStatistics/Pilot';

const explanation = []
explanation.push(<h4 key="header" className="heading-2 pb-1">Meeting Culture - Behavioral Change Analysis</h4>)
explanation.push(<p key="paragraph1">On this page we read the baseline data, and post pilot deployment to calculate the return on investment.</p>)
explanation.push(<p key="paragraph2">You will gain access to trends, and changes into the meeting behavior of your team.</p>)
explanation.push(<p key="paragraph3">All data you see on this page is based on 'Created At' date (instead of meeting's event date like in other analytics).</p>)

export default function MeetingPilotPage(props) {
  return (
    <Fragment>
      <PageTitle key="title" titleHeading="Meeting Culture - Impact and Savings Analysis" titleDescription="Dashboard for meeting organizer's behavioral changes, and meeting culture transformation. Use 'Deployment date' selector to start." explanation={explanation}/>

      <MeetingPilot flowtraceUser={ props.flowtraceUser }/>
    </Fragment>
  );
}
